import { useState } from "react";
import { Box, Typography, Stack, Divider, IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useData } from "../hooks/useData";

function CategorySelect({ canvas, onCategorySelect }) {
  const { signCategories, signCategoryState } = useData();
  const [dropDownOpen, setDropDownOpen] = useState(true);

  const handleDropDownClick = () => {
    setDropDownOpen((prev) => !prev); // Toggle dropdown (open if closed, close if open)
  };

  const handleCategorySelect = (category) => {
    onCategorySelect(category); // Call the parent handler to update category
    setDropDownOpen(false); // Close the dropdown after selection
  };

  return (
    <Box sx={{ textAlign: "left", padding: "10px" }}>
      <Typography
        variant="h5"
        sx={{
          color: "#0d2445",
          fontFamily: "Roboto",
          fontWeight: 700,
          textAlign: "left",
          marginBottom: "10px",
        }}
      >
        Select sign material
      </Typography>
      <Box sx={{ textAlign: "center" }}>
        {/* Dropdown Header */}
        <Box
          onClick={handleDropDownClick}
          sx={{
            color: "#0d2445",
            fontFamily: "Roboto",
            fontWeight: 700,
            textAlign: "left",
            margin: 0,
            marginBottom: "12px",
            padding: 1,
            width: "100%",
            minWidth: "200px",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "grey",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#f0f0f0",
            },
          }}
          role="button"
          aria-expanded={dropDownOpen}
          aria-label="Toggle sign material dropdown"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Typography sx={{ lineHeight: "24px" }}>
              {signCategoryState?.name || "Select a category"}
            </Typography>
            <IconButton size="small" aria-label="Toggle dropdown">
              <ArrowDropDownIcon
                sx={{
                  transform: dropDownOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s",
                }}
              />
            </IconButton>
          </Stack>
        </Box>
        {/* Dropdown Content */}
        {dropDownOpen && (
          <Box
            sx={{
              maxHeight: "300px",
              overflowY: "auto",
              bgcolor: "white",
              border: "1px solid grey",
              borderRadius: "4px",
              width: "100%",
            }}
          >
            {signCategories.map((category, index) => (
              <div key={category.id || index}>
                <Box
                  onClick={() => handleCategorySelect(category)}
                  sx={{
                    cursor: "pointer",
                    p: 1,
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                  role="option"
                  aria-selected={signCategoryState?.id === category.id}
                >
                  <Stack direction="row" spacing={2}>
                    <img
                      src={category.selectThumbnail}
                      alt={category.name}
                      width={50}
                      height={50}
                      style={{ objectFit: "cover" }}
                    />
                    <Stack
                      direction="column"
                      spacing={0}
                      alignItems="flex-start"
                    >
                      <Box sx={{ color: "#0d2445" }}>
                        <Typography
                          sx={{
                            fontFamily: "Roboto",
                            fontSize: "16px",
                            fontWeight: 600,
                            lineHeight: 1.5,
                            margin: 0,
                            padding: 0,
                            marginBottom: 1,
                            paddingLeft: "8px",
                          }}
                        >
                          {category.name}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontFamily: "Arial",
                            fontStyle: "italic",
                            color: "#0d2445",
                            fontWeight: 500,
                            fontSize: "12px",
                            margin: 0,
                            marginTop: -1,
                            marginBottom: 1,
                            padding: 0,
                            paddingLeft: "8px",
                            textAlign: "left",
                          }}
                        >
                          {category.brief}
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </Box>
                {index < signCategories.length - 1 && (
                  <Divider variant="fullWidth" orientation="horizontal" />
                )}
              </div>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default CategorySelect;
